<iris-card [elevation]="1">
  <div class="card-contents" data-test="connect-card">
    <h2>Connect with {{ firstName }}</h2>
    <div 
      *ngIf="soonestAvailableDate && accepting" 
      class="soonest-available" 
      data-test="soonest-available"
    >
      Soonest available session: {{ soonestAvailableDate | date:'EEEE LLLL d' }}
    </div>
    <div class="instructions">
      <p class="questions"> Want to book a session? Have questions? </p>
      <p>You can book a time that's right for you and message with {{ firstName }} after creating your free account.</p>
      <p class="call-to-action">Answer a few simple questions to get started!</p>
    </div>

    <iris-card-footer>  
      <iris-button
        id="connect-card-cta-button"
        class="request-session-button"
        data-test="request-session-button"
        (click)="onCtaClicked()"
      >
        {{ ctaButtonText }}
      </iris-button>
     </iris-card-footer>
  </div>
</iris-card>
